// extracted by mini-css-extract-plugin
module.exports = {"tosContainer":"TOS_tosContainer__38iw3","tosTitle":"TOS_tosTitle__2YVPw"};